// src/utils/dateUtils.js

export const formatDate = (timestamp) => {
    if (!timestamp?.seconds) return "Unknown Date";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

export const formatDateLong = (timestamp) => {
    if (!timestamp?.seconds) return "Unknown Date";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "long",
        year: "numeric",
    });
};

export const calculateDaysToGo = (timestamp) => {
    if (!timestamp?.seconds) return "TBA";

    const eventDate = new Date(timestamp.seconds * 1000);
    const today = new Date();

    // Calculate difference in time (milliseconds) and convert to days
    const differenceInTime = eventDate.getTime() - today.getTime();
    const daysToGo = Math.ceil(differenceInTime / (1000 * 3600 * 24));

    return daysToGo > 0 ? `${daysToGo} days to go` : "Event has started or passed";
};

